import { useState } from 'react';
import { Avatar, Box, Button, Flex, Text } from '@chakra-ui/react';
import { MentionsInput, Mention } from 'react-mentions';
import { useQuery } from 'urql';
import { ListUsersDocument } from '../../gql/graphql';
import data from './data.json';
import { useComments } from './useComments';

const AuthUser = data.currentUser;

interface CommentEditorProps {
  isUpdate?: boolean;
  replyingTo?: string;
  isNewComment?: boolean;
  id?: string;
  parentId?: string;
  closeEditor: () => void;
}
function CommentEditor({
  isUpdate,
  replyingTo,
  isNewComment,
  parentId,
  closeEditor,
}: CommentEditorProps) {
  const [commentText, setCommentText] = useState('');
  const { reply, addTopLevelComment } = useComments();

  const [{ data: listUsersData }] = useQuery({
    query: ListUsersDocument,
  });

  const _handleClick = () => {
    if (commentText === '') return;

    // reply
    if (!isUpdate && !isNewComment) {
      let cleanedText = removeTagFromCommentText().trim();
      reply(parentId, AuthUser, cleanedText, replyingTo);
      closeEditor();
    }

    // new Comment
    if (isNewComment) {
      addTopLevelComment(
        commentText,
        AuthUser,
         undefined
      );
      closeEditor();
    }

    // // update
    // if (isUpdate) {
    //   console.log('update clicked');
    //   updateComment(id!, parentId, commentText);
    //   closeEditor();
    // }

    reset();
  };

  function reset() {
    setCommentText('');
  }

  // Define a function to extract the plain text without mentions
  const removeTagFromCommentText = () => {
    return commentText.replace(/@\w+\s/g, ''); // This regex removes mentions like "@username "
  };

  return (
    <Box
      className="comment"
      bg={'white'}
      borderRadius={'xl'}
      my={4}
      p={5}
      boxShadow={'sm'}
    >
      <Box>

        <Flex alignItems={'start'} justifyContent="space-between">
          {/* User Image */}
          <Avatar bg="brand.400" size="sm" />
          {/* New Comment Box */}
          <Box width={'35vh'}>
            <MentionsInput
              value={commentText}
              autoFocus={true}
              onChange={(e) => {
                setCommentText(e.target.value);
              }}
              placeholder={`${
                isNewComment ? 'Write a new comment' : 'Write a new reply'
              } @username...`}
            >
              <Mention
                trigger="@"
                data={
                  listUsersData?.listUsers
                    ? listUsersData?.listUsers.map((user) => ({
                        id: user.id,
                        display: user.email,
                      }))
                    : []
                }
                renderSuggestion={(suggestion) => (
                  <div>{suggestion.display}</div>
                )}
              />
            </MentionsInput>
            {/* <Checkbox
              isChecked={includeSelectionChecked}
              onChange={(e) => setIncludeSelectionChecked(e.target.checked)}
            >
              Include current selection
            </Checkbox> */}
          </Box>

          <Button
            onClick={() => _handleClick()}
            _hover={{
              opacity: 0.6,
            }}
          >
            <Text fontWeight={'black'} color={'white'}>
              {isUpdate ? 'Update' : isNewComment ? 'Send' : 'Reply'}
            </Text>
          </Button>
        </Flex>
      </Box>
    </Box>
  );
}

export default CommentEditor;
